import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * RC10m · Medical Card Renewal banner.
 *
 * Rendered on the Tour's Driver assignment area above the assignment
 * row (and above any RC10l Coverage Needed card if both conditions
 * apply simultaneously — this banner stacks ABOVE). Persistent while
 * `medical_expiry_warning_active=true` on the assignment. Clears
 * server-truth only — no optimistic hiding.
 */
function fmtMMDDYYYY(iso) {
  if (!iso || typeof iso !== "string") return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${m}/${d}/${y}`;
}

export default function MedicalRenewalBanner({ assignment, driverLabel }) {
  if (!assignment || assignment.medical_expiry_warning_active !== true) return null;
  const exp = assignment.medical_expiration_at_acknowledgment;
  const expMMDDYYYY = fmtMMDDYYYY(exp);
  const roleLabel = (assignment.is_fill_in
    ? "fill-in"
    : (assignment.role || "primary_driver").replace(/_/g, " "));
  return (
    <div
      className="border border-amber-hold/70 bg-amber-hold/15 rounded-sm px-3 py-2 mb-2 flex items-start gap-2"
      data-testid={`rc10m-renewal-banner-${assignment.id}`}
    >
      <AlertTriangle size={16} className="text-amber-hold mt-0.5 shrink-0" />
      <div className="min-w-0 text-[12.5px] text-carbon">
        <div className="font-semibold uppercase tracking-widest text-[10.5px] text-amber-hold">
          Medical Card Renewal Required
        </div>
        <div data-testid={`rc10m-renewal-wording-${assignment.id}`}>
          expires{" "}
          <span className="font-mono tabular" data-testid={`rc10m-renewal-date-${assignment.id}`}>
            {expMMDDYYYY}
          </span>
        </div>
        <div className="text-[11.5px] text-steel">
          Driver: <span className="text-carbon">{driverLabel || assignment.driver_id?.slice(0, 8)}</span>
          {" · "}Role: <span className="text-carbon">{roleLabel}</span>
        </div>
      </div>
    </div>
  );
}
